import Header from './Header.jsx';
import BaseModal from '../widgets/BaseModal.jsx';
import ProjectCard from '../widgets/ProjectCard.jsx';

export default function Projects({data = []}) {
    return (
        <>
            <div className="relative">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6 pb-10">
                    {data?.map((item, index) => (
                        <ProjectCard key={item?.project_id || index} data={item} index={index}/>
                    ))}
                </div>
            </div>
        </>
    );
}
